import { render, staticRenderFns } from "./JobTechnicianMessagePart.vue?vue&type=template&id=107154b6&"
import script from "./JobTechnicianMessagePart.vue?vue&type=script&lang=js&"
export * from "./JobTechnicianMessagePart.vue?vue&type=script&lang=js&"
import style0 from "./JobTechnicianMessagePart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports